export default {
  ok: 'OK',
  cancel: 'Cancel',
  clear: 'Clear',
};
